import type { ManageAssetsTabSlug } from "./manageAssetsTabs";
import { manageAssetsPath } from "./manageAssetsTabs";

export function resolveReturnDestination(
  returnPath?: string,
  returnSearch?: string,
  defaultTab: ManageAssetsTabSlug = "apis",
): string {
  if (returnPath) {
    const search = returnSearch?.startsWith("?")
      ? returnSearch
      : returnSearch
        ? `?${returnSearch}`
        : "";
    return `${returnPath}${search}`;
  }
  return manageAssetsPath(defaultTab);
}
